import { render, staticRenderFns } from "./rbDataDetail.vue?vue&type=template&id=76cf988a&lang=pug&"
import script from "./rbDataDetail.vue?vue&type=script&lang=js&"
export * from "./rbDataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports